module.exports = __webpack_public_path__ + "img/Singapore.f85f909f.svg";